<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <div>
        <div v-if='btns.del'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-remove" :title="$t('SubscriberIms.del')" @click='buttonClk("del")'/></div>
        <div v-if='btns.mod'><button class="e-btn e-tbar-btn icon hero-icon hero-icon-edit" :title="$t('SubscriberIms.mod')" @click='buttonClk("mod")'/></div>
      </div>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'GroupMemberTableMenu',
  data() {
    return {
      components: {

      },
      btns: {
        mod: true,
        del: true,
      },
    };
  },
  methods: {
    buttonClk(args) {
      this.$emit('methodEnum', args);
    },
  }
};
</script>

<style scoped>

</style>
